import { Row, Col } from 'antd';

const Section = ({children, responsive, style}) => {
    if (responsive) {
        return (
            <Row style={style}>
                <Col xs={1} sm={1} md={2} lg={3} xl={4}/>
                <Col xs={22} sm={22} md={20} lg={18} xl={16}>{children}</Col>
                <Col xs={1} sm={1} md={2} lg={3} xl={4}/>
            </Row>
        )
    } else {
        return (
            <Row style={style}>
                <Col span={24}>{children}</Col>
            </Row>
        )
    }
}

export default Section;